import { render, staticRenderFns } from "./peopleSelectionNotes.vue?vue&type=template&id=116d8616&"
import script from "./peopleSelectionNotes.vue?vue&type=script&lang=js&"
export * from "./peopleSelectionNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports